module.exports = __webpack_public_path__ + "static/media/device_driver.5381e405.jpg";